import React, { useState } from 'react';
import { joinWaitlist } from '../../service/userService'; // Import the joinWaitlist function
import globalStyles from '../globals.module.css';
import componentStyles from './waitlist.module.css';
import PageView from '../common/pageView';

// Waitlist component to manage user sign-ups for a waitlist
const Waitlist = () => {
    // State to hold the email input by the user
    const [email, setEmail] = useState('');
    // State to manage the submission status
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    // Function to handle the input change
    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    // Function to handle form submission
    const handleSubmit = async (event) => {
        event.preventDefault(); // Prevent the default form submission behavior
        try {
            let response = await joinWaitlist(email); // Call the joinWaitlist API
            const { data } = response;
            if (data.success) {
                setSubmitted(true); // Update the submission status
            } else {
                setError('Failed to join the waitlist. Please try again.'); // Set error message
                console.error(data.error);
                setSubmitted(false);
            }
        } catch (err) {
            setError('Failed to join the waitlist. Please try again.'); // Set error message
            console.error(err);
            setSubmitted(false);
        }
    };

    return (
        <PageView title="Waitlist" contentClassName={componentStyles.waitlistContent}>
            {submitted ? (
                <section className={`${globalStyles.standardSection} ${componentStyles.waitlistPanel}`}>
                    <div className={componentStyles.statusLabel}>Request received // confirmed</div>
                    <p className={componentStyles.successMessage}>Thank you for joining the waitlist.</p>
                </section>
            ) : (
                <section className={`${globalStyles.standardSection} ${componentStyles.waitlistPanel}`}>
                    <div className={componentStyles.statusLabel}>Early access // registration</div>
                    <p className={componentStyles.description}>Enter your email to receive product access updates.</p>
                    <form className={globalStyles.form} onSubmit={handleSubmit}>
                        <div className={globalStyles.formGroup}>
                            <label>Email</label>
                            <input className={globalStyles.standardInput} type="email" value={email} onChange={handleEmailChange} placeholder="Enter your email" required />
                        </div>
                        {error && <div className={componentStyles.errorMessage}>{error}</div>}
                        <button type="submit" className={globalStyles.primaryButton}>Join Waitlist</button>
                    </form>
                </section>
            )}
        </PageView>
    );
};

export default Waitlist;
